/**
 * Panneaux d'information du HUD conservés de la première version : alertes
 * avec actions, notifications passagères et bandeau de connexion ou de pause.
 * La barre du haut, l'affluence en direct, la fiche de sélection et la
 * fenêtre de direction sont dans topbar.tsx, inspector.tsx et office.tsx.
 */
import { TriangleAlert } from 'lucide-preact';
import { formatClock } from '@snowchain/shared';
import { Badge, Button, EventNotice, HudPanel, ToastView } from './components';
import { command, focusEntity, hud } from './context';
import { ui } from './ui-state';

export { LIFT_STATUS, REGIME } from './labels';

export function AlertsPanel() {
  void ui.tick.value;
  const store = hud.store;
  const r = store?.replica;
  if (!store || !r) return null;
  const alerts = r.me?.alerts ?? [];
  // Rien à signaler : une simple pastille, l'écran reste dégagé (comme dans les jeux de gestion).
  if (store.isOwner && alerts.length === 0)
    return (
      <div class="g-alerts-ok" role="status">
        <i /> Aucune alerte
      </div>
    );
  return (
    <HudPanel class="kh-alerts" title={alerts.length ? `Alertes \u00b7 ${alerts.length}` : 'Alertes'} icon={TriangleAlert}>
      {!store.isOwner && <EventNotice level="info" title="Mode observateur" message="Vous suivez cette station en direct. Seul son gérant peut agir." />}
      {alerts.slice(0, 5).map((a) => (
        <EventNotice
          key={a.id}
          level={a.level}
          title={a.title}
          message={a.message}
          meta={formatClock(a.gameTime).split(' \u00b7 ')[1]}
          onTitle={a.focus ? () => focusEntity(a.focus!.kind, a.focus!.id) : undefined}
        >
          {a.action && (
            <Button size="sm" onClick={() => void command(a.action!.command, `${a.action!.label} : demande envoyée`)}>
              {a.action.label}
            </Button>
          )}
          <Button size="sm" variant="ghost" onClick={() => void command({ type: 'dismissAlert', id: a.id })}>
            Ignorer
          </Button>
        </EventNotice>
      ))}
    </HudPanel>
  );
}

export function Toasts() {
  const list = ui.toasts.value;
  return (
    <div class="kh-toasts">
      {list.map((t) => (
        <ToastView key={t.id} level={t.level} title={t.title} message={t.message} />
      ))}
    </div>
  );
}

export function Banner() {
  void ui.tick.value;
  const store = hud.store;
  if (!store) return null;
  if (store.status === 'offline' || store.status === 'connecting')
    return (
      <div class="kh-banner">
        <Badge tone="warn" pulse>
          {store.status === 'connecting' ? 'Connexion' : 'Hors ligne'}
        </Badge>
        <span>{store.statusDetail || 'Reconnexion au serveur...'}</span>
      </div>
    );
  if (store.replica && store.clock.speed === 0)
    return (
      <div class="kh-banner">
        <Badge tone="info">Pause</Badge>
        <span>Simulation en pause sur le serveur</span>
      </div>
    );
  return null;
}
